window.swiperScriptsTest = false;
async function initSwipers() {
  const productSlider = new Swiper(".c-hp-product-slider", {
    slidesPerView: 1.3,
    spaceBetween: 10,
    breakpoints: {
      460: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      550: {
        slidesPerView: 2.2,
        spaceBetween: 10,
      },
      710: {
        slidesPerView: 3,
        spaceBetween: 5,
      },
      915: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
      1200: {
        slidesPerView: 5,
        spaceBetween: 10,
      },
    },
    navigation: {
      nextEl: ".c-hp-product-slider .swiper-button-next",
      prevEl: ".c-hp-product-slider .swiper-button-prev",
    },
  });

  const influencerSectionid = new Swiper(
    "#influencerSection-id .influencerSectionSwiper",
    {
      slidesPerView: 2,
      spaceBetween: 0,
      breakpoints: {
        410: {
          slidesPerView: 2,
        },
        500: {
          slidesPerView: 2,
        },
        724: {
          slidesPerView: 3,
        },
        940: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 4,
        },
        1216: {
          slidesPerView: 5,
        },
        1400: {
          slidesPerView: 6,
        },
      },
      navigation: {
        nextEl: "#influencerSection-id .swiper-button-next",
        prevEl: "#influencerSection-id .swiper-button-prev",
      },
    }
  );

  const homePageMobileAppV2Slider = new Swiper(
    ".c-hp-social-mobile-app .home-page-mobile-app-v2-slider",
    {
      loop: "true",
      effect: "coverflow",
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: "auto",

      breakpoints: {
        0: {
          coverflowEffect: {
            rotate: 0,
            stretch: 150,
            depth: 700,
            modifier: 1,
            slideShadows: false,
          },
        },
        340: {
          coverflowEffect: {
            rotate: 0,
            stretch: 190,
            depth: 700,
            modifier: 1,
            slideShadows: false,
          },
        },
        420: {
          coverflowEffect: {
            rotate: 0,
            stretch: 220,
            depth: 700,
            modifier: 1,
            slideShadows: false,
          },
        },
        767: {
          coverflowEffect: {
            rotate: 0,
            stretch: 320,
            depth: 700,
            modifier: 1,
            slideShadows: false,
          },
        },
        1024: {
          coverflowEffect: {
            rotate: 0,
            stretch: 150,
            depth: 700,
            modifier: 1,
            slideShadows: false,
          },
        },
        1200: {
          coverflowEffect: {
            rotate: 0,
            stretch: 200,
            depth: 700,
            modifier: 1,
            slideShadows: false,
          },
        },
        1400: {
          coverflowEffect: {
            rotate: 0,
            stretch: 250,
            depth: 700,
            modifier: 1,
            slideShadows: false,
          },
        },
      },
      navigation: {
        nextEl: ".c-hp-social-mobile-app .hp-mobile-app-v2-next",
        prevEl: ".c-hp-social-mobile-app .hp-mobile-app-v2-prev",
      },
    }
  );

  window.localStorage.removeItem("hpValues");

  // c-hp-product-slider.liquid js codes below
  const jsonUrl = document.querySelector("#c-hp-product-slider").dataset
    .marketJsonUrl;
  const makeModelJsonUrl = jsonUrl
    .replace("_market", "_makeModel")
    .split("?")[0];
  window.makeModelArr = await getMakeModelJSON(makeModelJsonUrl);

  const marketJson = await fetch(jsonUrl).then((res) => res.json());
  const pcUnitCards = document.querySelectorAll(".product-cart");

  async function getData(url) {
    try {
      let res = await fetch(url);
      if (!res.ok) {
        console.log("fetch failed");
        throw new Error("something went wrong :( ");
      }
      let data = res.json();
      // console.log(data)
      return data;
    } catch (err) {
      throw new Error(err);
    }
  }

  pcUnitCards.forEach((pcUnitCard) => {
    pcUnitCard.addEventListener("click", async (e) => {
      // console.log(marketJson);
      const { make, model } = pcUnitCard.dataset;
      const brandData = marketJson.find(
        (item) => item.make.toLowerCase() === make.toLowerCase()
      );
      if (!brandData) {
        console.error("can not find brand");
        return;
      }
      // console.log(make, "===> make");
      // console.log(model, "===> model");
      // console.log(brandData);
      const normalizedModel = model.toLowerCase().replaceAll("-", "");
      const modelData = brandData.models.find((item) => {
        const normalizedItemModel = item.model
          .toLowerCase()
          .replaceAll("-", "");
        return (
          normalizedItemModel === normalizedModel ||
          normalizedItemModel.includes(normalizedModel)
        );
      });

      if (!modelData) throw new Error("can not get modelData");
      let parentEl = e.target.closest(".product-cart");

      let variantsParent = parentEl.querySelector(
        ".product-card-variantsParent"
      );
      let href = pcUnitCard.getAttribute("data-href");

      // if (
      //   !(
      //     e.target.classList.contains("pcUnitCard") ||
      //     e.target.classList.contains("variantEngine") ||
      //     e.target.classList.contains("variantYear") ||
      //     e.target.classList.contains("redictToPp")
      //   )
      // ) {
      //   console.log(e.target);
      //   if (window.swiperScriptsTest === true) return;
      //   redirectPPFunc(make, model, "", href);
      //   return;
      // }
      let customSpinnerParent = parentEl.querySelector(".customSpinnerParent");
      customSpinnerParent.style.display = "block";
      if (modelData) {
        customSpinnerParent.style.display = "none";
        let variants = modelData.variants;
        variants.sort((a, b) => {
          if (variants.indexOf(a) < variants.indexOf(b)) return 1;
          else if (variants.indexOf(a) > variants.indexOf(b)) return -1;
          else return 0;
        });
        variantsParent.style.display =
          variantsParent.style.display === "flex" ? "none" : "flex";
        if (variants.length < 7)
          variantsParent.style.justifyContent = "safe center";
        variants.forEach((variant) => {
          const { id: variantID, title: variantTitle } = variant;
          let variantPC = variant.socket;
          let variantYear = variant.body;
          let variantEngine = variant["engine-volume"];

          //EXTRACTS "PC{digit}" from variant socket
          const variantPcCode = variant.socket.match(/PC\d+/)?.[0];
          const isOutOfStock =
            window.outOfStockPcCodes?.includes(variantPcCode);
          // console.log(variantPcCode);
          // console.log(window.outOfStockSockets);
          // console.log(isOutOfStock);
          // const isOutOfStock = false;
          let li = document.createElement("li");
          if (isOutOfStock) li.classList.add("out-of-stock");
          const onClick = `onclick="redirectPPFunc('${make}','${model}','${variantYear}','${href}')"`;
          li.innerHTML = `<button ${isOutOfStock ? "" : onClick}  >
                              <span>${variantYear}</span>
                              <span class="variantEngine">${variantEngine}</span>
                              <span class="out-of-stock-indicator">${
                                Shopify.locale === "de"
                                  ? "NICHT AUF LAGER"
                                  : "OUT OF STOCK"
                              }</span>
                        </button>`;
          variantsParent.appendChild(li);
        });
      }
    });
  });

  async function getMakeModelJSON(url) {
    if (!window.checkProductPage) return null;
    const response = await fetch(url)
      .then((res) => res.json())
      .catch((err) => {
        console.error(err);
      });
    return response.createdMakeModel;
  }
}
async function redirectPPFunc(make, model, body, href) {
  if (make == "undefined") return;
  window.localStorage.setItem(
    "hpValues",
    JSON.stringify({ make, model, body })
  );

  const genericPPUrl = `${window.Shopify.routes.root}${href}`;
  if (!window.checkProductPage) {
    // Parameters comes from markets' sections/INT_c-hp-swiper-scripts.liquid
    window.location.href = genericPPUrl;
    return;
  }

  // Checks makeModel.json for models that have special product page
  const specialProducts = window.makeModelArr?.find(
    (item) => item.make === make
  )?.specialProductPage;
  if (!specialProducts?.includes(`${make} ${model}`)) {
    window.location.href = genericPPUrl;
    return;
  }
  const productUrl = `${window.Shopify.routes.root}products/${make
    .replaceAll(" ", "-")
    .toLowerCase()}-${model.replaceAll(" ", "-").toLowerCase()}`;
  const shouldRedirectToGenericPP = await fetch(productUrl).then(
    (res) => res.status === 404
  );
  if (window.swiperScriptsTest == true) return;
  window.location.href = shouldRedirectToGenericPP ? genericPPUrl : productUrl;
}
document.addEventListener("DOMContentLoaded", initSwipers);
